import { AxiosError } from 'axios';

import { LEADS_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { Lead } from '@/types/lead.type';
import { ApiResponse } from '@/types/response.type';

const getLead = async (leadId: string): Promise<ApiResponse<Lead>> => {
  try {
    const response = await apiManager.get(`${LEADS_API_URL}/${leadId}`, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default getLead;
